import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/css/tax.css';
import TaxList from './components/TaxList';
import TaxDetails from './components/TaxDetails';

const App = () => {
    const [addNew, setAddNew] = useState(false);
    const [TaxIdToEdit, setTaxIdToEdit] = useState(null);

    const handleEdit = (id) => {
        setAddNew(true);
        setTaxIdToEdit(id);
    };

    return (
        <>
            <div className="flex items-center gap-8 h-12">
                <p className="text-ec-body font-semibold font-inter lg:text-xl md:text-lg leading-8">
                    {!addNew ? 'Tax Classes' : 'Add Tax Class'}
                </p>
                {!addNew && (
                    <button
                        type="button"
                        onClick={() => setAddNew(true)}
                        className="w-[125px] h-12 flex justify-center items-center gap-[8px] 
                        bg-white group border border-ec-primary rounded-lg 
                        text-ec-primary hover:text-white hover:bg-ec-primary focus:shadow-none 
                        focus:text-white focus:bg-ec-secondary lg:text-sm md:text-xs sm:text-sm 
                        transition-all ease-in-out duration-500 font-inter font-medium text-base text-center leading-[26px]"
                    >
                        <svg
                            class="w-4 h-4 font-medium"
                            data-slot="icon"
                            fill="none"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            ></path>
                        </svg>
                        Add Class
                    </button>
                )}
            </div>

            {!addNew && (
                <TaxList
                    handleEdit={handleEdit}
                    handleAddNew={() => setAddNew(true)}
                />
            )}
            {addNew && (
                <TaxDetails
                    hideAddNew={() => setAddNew(false)}
                    taxId={TaxIdToEdit}
                />
            )}
            <ToastContainer />
        </>
    );
};

const container = document.getElementById('easycommerce-tax-classes');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

export default App;
